import { SxProps, Theme } from '@mui/material/styles';

export const buttonSx = {
  alignItems: 'center',
  width: '117px',
  height: '40px',
  padding: '8px',
  gap: '8px',
};

export const textSx: SxProps<Theme> = (theme: Theme) => ({
  fontWeight: 500,
  fontSize: '14px',
  color: theme.palette.primary.main,
});
